<template>
  <div class="home">
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col class="text-center">
          <QuickLinks/>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import QuickLinks from "@/components/QuickLinks.vue";

export default defineComponent({
  name: 'Home',
  components: {
    QuickLinks
  }
});
</script>
